var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-constraint"},[_c('am2-message-select',{attrs:{"value":_vm.value},on:{"select":_vm.handleSelectClick,"clear":_vm.handleClear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }